<template>
    <div class="list-raovat">
        <!-- khối fillter và xử lý muti -->
        <actionTable
            :idSelect="idSelect"
            v-model="data_fillter"/>
        <!-- table list rao vặt -->
        <table :class="{
                'table': true,
                'table-borderless': $detect == 'web'
            }">
            <!-- thead web -->
            <thead v-if="$detect == 'web'">
            <tr>
                <th scope="col" class="text-center">
                   No.
                </th>
                <th scope="col" class="text-center">Thời gian nạp</th>
                <th scope="col">Hình thức nạp điểm</th>
                <th scope="col" style="text-align: right">Số điểm nạp</th>
            </tr>
            </thead>
            <!-- hết thead web -->

            <!-- thead mobile -->
            <thead v-else>
            <tr>
                <th scope="col" class="text-center py-1">
                       No.
                </th>
                <th scope="col" class="text-center py-1">Thông tin</th>
            </tr>
            </thead>
            <!-- hết thead mobile -->

            <!-- tbody -->

            <!-- check xem có dữliệu hay không -->
            <tbody v-if="raovat.length == 0">
            <tr>
                <td colspan="8" class="text-center text-muted">Không có dữ liệu</td>
            </tr>
            </tbody>

            <!-- có dữ liệu -->
            <!-- tbody web -->
            <tbody v-else-if="$detect == 'web'">
            <tr :class="{
                        'position-relative': true,
                    }" v-for="(item,index) in raovat" :key="index">
                <td scope="row " class="text-center" style="white-space: nowrap;">
                    {{item.id}}
                </td>
                <td  class="text-center">
                    {{item.date}}
                </td>
                <td class="name-rv">
                    {{item.type}}
                </td>
                <!-- td lượt xem -->
                <td class="text-right text-danger font-weight-bolder">
                    <p v-html="item.money"></p>
                </td>
                <!-- td giá tin rao -->
            </tr>
            </tbody>
            <!-- hết tbody web -->

            <!-- tbody mobile -->
            <tbody v-else>
            <tr :class="{
                        'table-mobile position-relative': true,
                    }" v-for="(item, index) in raovat" :key="index">
                <!-- td ảnh và checkbox -->
                <td class="img-tab position-relative pl-1">
                    <div class="checkbox-mobile position-absolute">
                         {{item.id}}
                    </div>
                </td>
                <!-- td thông tin -->
                <!-- click thông tin là show model xử lý -->
                <!-- <td style="width: calc(100% - 100px)" @click="actionItem(item)"> -->
                <td  :width="widthTable - 100" class="position-relative"
                     @click="activeTr = index">
                    <div class="name">{{item.date}}</div>
                    <div class="d-flex justify-content-between mt-2">
                        {{item.type}}
                    </div>
                    <div class="d-flex justify-content-between mt-2">
                        <div class="price-tab" v-html="item.money"></div>
                    </div>
                </td>
            </tr>
            </tbody>
            <!-- hết tbody mobile -->
        </table>
        <paginate
            :current_page="current_page"
            :next_page="next_page"
            :last_page="last_page"
            :callData="getData"/>

        <!-- khối dialog xử lý up vip, siêu vip -->
        <actionDialog
            :action="action"
            :visible.sync="dialog"
            :data="itemaction"
            :multiple="false"/>

        <ldc-dialog
            title="Lý do bị từ chối"
            :clickoutside="true"
            :class="{
                'modal-reason' : $detect == 'web',
                'modal-reason-mobile' : $detect == 'mobile'
                }"
            width="50%"
            :fullscreen="$detect == 'mobile'"
            :visible.sync="dialogApprove">
            <div v-html="approve.approve" v-if="approve && approve.approve" class="main-reason"></div>
            <p class="mb-0 p-3 fw-600" v-else>Lý do chưa xác định</p>
            <p class="mb-0 ps-reason px-3 pb-3 text-danger fw-600">Tham khảo:
                <a href="http://help.vatgia.com/quy-dinh-dang-rao-vat-n19/" target="_blank" class="ml-1 fw-400">Quy định đăng tin rao vặt</a>
            </p>
            <div class="footer-modal p-10px text-center">
                <button class="btn btn-success px-5"
                        v-if="approve"
                        @click="update(approve.id)">
                    <i class="icon ion-md-create mr-2"></i>Sửa tin
                </button>
            </div>
        </ldc-dialog>
    </div>
</template>
<script>
export default {
    components: {
        paginate: () => import('@/components/layout/pagination.vue'),
        actionTable: () => import('./fillter.vue'),
        actionDialog: () => import('@/components/profile/raovat/actionDialog.vue'),
    },
    data(){
        return {
            raovat: [], // data rao vặt
            activeTr: '', // hiện tại k sử dụng (check lại)
            current_page: 0, // page hiện tại
            next_page: 0, // next page
            last_page: 0, // last page
            idSelect: [], // id rao vặt select để sử lý muti
            data_fillter: {
                type: this.$route.query.type ? this.$route.query.type*1 : '',
                keyword: this.$route.query.keyword,
                day_form: this.$route.query.day_form,
                day_to: this.$route.query.day_to,
                page: this.$route.query.page ? this.$route.query.page*1 : '',
            }, // data fillter
            selectAll: false, // trạng thái có select all hay không
            dataActionItem: {}, // data xử lý đơn
            showModel: false, // show model xử lý đơn moblie
            screenWidth: window.screen.width, // lấy kích thước màn hình
            dialog: false, // show dialog xử lý up vip, up siêu vip
            action: '', // loại xử lý (up vip hoặc up siêu vip) để có giao diện khác
            itemaction: '', // data xử lý đơn
            loading: '', // loading theo tr
            loadingAction: '', // loading theo xử lý
            dialogApprove: false, //trạng thái bật lý do không được duyệt
            approve: null, // lý do không được phê duyệt
        }
    },
    created() {
        apiGet('/v2/profile/money/history', this.data_fillter).then(res => {
            let data = res.data;
            this.raovat = data.data;
            this.last_page = data.last_page;
            this.next_page = data.next_page;
            this.current_page = data.current_page;
            this.selectAll = false;
        });
        this.$eventBus.$on('call-rv-current-page', () => this.getData((this.current_page)))
    },
    methods: {
        /**
         *  lấy data rao vặt
         *
         *  page: page cần lấy dữu liệu
         */
        async getData(page){
            // lấy data fillter
            let fillter = {
                page: page,
                type: this.data_fillter.type,
                keyword: this.data_fillter.keyword,
                day_form: this.data_fillter.day_form,
                day_to: this.data_fillter.day_to,
            };
            let query = {};
            if(fillter.page) query.page = fillter.page;
            if(fillter.type) query.type = fillter.type;
            if(fillter.keyword) query.keyword = fillter.keyword;
            if(fillter.day_form) query.day_form = fillter.day_form;
            if(fillter.day_to) query.day_to = fillter.day_to;
            this.$router.push({
                name: 'history-money',
                query: query
            })
        },

        /**
         *  lấy data đẩy vào model xử lý đơn mobile
         */
        actionItem(item){
            this.dataActionItem = item;
            this.showModel = true;
        },

        /**
         * push id rao vặt mobile
         */
        pushIdMuti(item){
            if(item.status == 1 && item.status_expire === 1){
                if(this.idSelect.includes(item.id)){
                    let index = this.idSelect.indexOf(item.id);
                    this.idSelect.splice(index, 1);
                }else{
                    this.idSelect.push(item.id);
                }
            }
        },

        /**
         * xử lý đơn
         *
         * item: data xử lý
         * check: loại xử lý
         */
        actionUpItem(item, check){
            this.itemaction = item;
            this.action = check;
            this.dialog = true;
        },


    },
    watch: {
        query:{
            handler(val){
                apiGet('/v2/profile/money/history', {
                    type: val.type ? val.type*1 : '',
                    keyword: val.keyword,
                    page: val.page ? val.page*1 : '',
                    day_form : val.day_form,
                    day_to : val.day_to
                }).then(res => {
                    let data = res.data;
                    console.log(data)
                    this.raovat = data.data;
                    this.last_page = data.last_page;
                    this.next_page = data.next_page;
                    this.current_page = data.current_page;
                    this.selectAll = false;
                });
            },
            deep: true
        },
        data_fillter: {
            handler(val){
                this.getData(1)
            },
            deep: true
        },


        showModel(val){
            if(!val){
                this.dataActionItem = {};
            }
        }
    },
    computed: {
        widthTable(){
            let table = document.querySelector('table');
            return table.clientWidth;
        },
        query(){
            return this.$route.query;
        }
    },
}
</script>
